import React from "react";
import { Card } from "@/components/ui/card";
import { type CaixaLotteryType } from "@/utils/caixa";

interface CaixaPredictionCardProps {
  numbers: string[];
  lotteryType: CaixaLotteryType;
  index: number;
}

const CaixaPredictionCard: React.FC<CaixaPredictionCardProps> = ({ 
  numbers, 
  lotteryType, 
  index 
}) => {
  const getCardColor = () => {
    switch (lotteryType) {
      case "mega-sena":
        return "bg-gradient-to-br from-green-100 to-green-200 dark:from-green-900/30 dark:to-green-800/30 border-green-300 dark:border-green-600";
      case "quina":
        return "bg-gradient-to-br from-purple-100 to-purple-200 dark:from-purple-900/30 dark:to-purple-800/30 border-purple-300 dark:border-purple-600";
      case "lotomania":
        return "bg-gradient-to-br from-orange-100 to-orange-200 dark:from-orange-900/30 dark:to-orange-800/30 border-orange-300 dark:border-orange-600";
      case "lotofacil":
        return "bg-gradient-to-br from-pink-100 to-pink-200 dark:from-pink-900/30 dark:to-pink-800/30 border-pink-300 dark:border-pink-600";
      case "dupla-sena":
        return "bg-gradient-to-br from-red-100 to-red-200 dark:from-red-900/30 dark:to-red-800/30 border-red-300 dark:border-red-600";
      case "dia-de-sorte":
        return "bg-gradient-to-br from-yellow-100 to-yellow-200 dark:from-yellow-900/30 dark:to-yellow-800/30 border-yellow-300 dark:border-yellow-600";
      default:
        return "bg-gradient-to-br from-blue-100 to-blue-200 dark:from-blue-900/30 dark:to-blue-800/30 border-blue-300 dark:border-blue-600";
    }
  };

  return (
    <Card className={`${getCardColor()} p-4 hover:shadow-lg transition-all duration-300 hover:scale-105 w-full max-w-[300px]`}>
      <div className="text-center space-y-3">
        <div className="text-xs font-bold text-muted-foreground uppercase tracking-wide">
          Jogo #{index + 1}
        </div>
        
        <div className="flex flex-wrap justify-center gap-2">
          {numbers.map((number, idx) => (
            <div
              key={idx}
              className="w-8 h-8 bg-white dark:bg-gray-800 rounded-full flex items-center justify-center text-sm font-bold shadow-sm border"
            >
              {number}
            </div>
          ))}
        </div>
        
        <div className="text-xs text-muted-foreground">
          {numbers.length} números selecionados
        </div>
      </div>
    </Card>
  );
};

export default CaixaPredictionCard;
